<template>
  <div class="mt-48">
    <div class="container max-w-screen-2xl">
      <div class="grid grid-cols-2 gap-x-16 items-center">
        <div class="">
          <img src="@/assets/img/samples/features/failed-payments/recovery-hero.svg" alt="Dunning" class="w-full" />
        </div>
        <div class="max-w-lg">
          <p class="title">Time to start recovering <span class="text-green-500"> 50% or more</span> of failed payments.</p>
          <p class="subtitle mt-4 text-brand-brown">
            Just click to get your campaigns in place. They're already written for you with the latest practices in mind. We do recommend taking a
            moment to vary up sender name and reply-to emails. This maximizes open rates.
          </p>
          <div class="space-y-6 mt-8" v-loading="loading">
            <div v-for="step in steps" :key="step.value" class="flex items-center space-x-4" style="max-width: 420px">
              <button
                class="flex items-center space-x-4 rounded-lg px-4 py-4 flex-grow"
                @click="handleStepClick(step)"
                :disabled="!!step.completed"
                :class="[step.completed ? 'cursor-default bg-gray-600' : 'bg-gray-800 cursor-pointer hover:bg-gray-700 transition-colors']"
              >
                <span class="px-2.5 py-1 border-gray-400 border-2 rounded-md bg-gray-600 text-white text-xs font-bold">
                  {{ step.shortcut }}
                </span>
                <span class="text-white font-bold" :class="[step.completed ? 'line-through' : '']">{{ step.label }}</span>
              </button>
              <div class="w-24">
                <div v-if="step.completed" class="text-brand-black text-sm font-semibold flex items-center space-x-1.5">
                  <font-awesome-icon :icon="['fas', 'check']" class="text-xs"></font-awesome-icon>
                  <span>Done</span>
                </div>
                <div v-else class="text-brand-black text-sm font-medium">
                  {{ step.hint }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CREATE_DUNNING_CAMPAIGN_BLUEPRINT, SYNC_DUNNING } from '@/store/action-types';
import { mapGetters } from 'vuex';

const onboardSteps = [{ value: 'campaignCreated', label: 'Create your campaigns', shortcut: 'return', hint: 'Takes 1 min' }];

export default {
  name: 'DunningOnboard',
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['dunningOnboardState']),
    steps() {
      return onboardSteps.map((step) => ({
        ...step,
        completed: this.dunningOnboardState[step.value],
      }));
    },
  },
  mounted() {
    document.addEventListener('keyup', this.onKeyup);
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.onKeyup);
  },
  methods: {
    onKeyup(event) {
      if (event.key === 'Enter') {
        this.createCampaign();
      }
    },
    async handleStepClick(step) {
      if (step.completed) {
        return;
      }
      if (step.value === 'campaignCreated') {
        this.createCampaign();
      }
    },
    async createCampaign() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      let blueprint;
      if (!this.primaryCampaignBlueprintId) {
        // by default this will generate one if not passed as payload
        blueprint = await this.$store.dispatch(CREATE_DUNNING_CAMPAIGN_BLUEPRINT);
        await this.$store.dispatch(SYNC_DUNNING);
        this.$router.push({ name: 'dunningcampaign', params: { id: blueprint._id } });
      }
    },
  },
};
</script>
